<template>
<div>       
    <!-- <div v-if="is_conclusion_loaded==true" class="py-3"> -->
        <!-- <b-button class="float-right" id="submit_audit" :disabled="final_completed==true" variant="blue" @click="showSubmitAudit">
            <fa icon="paper-plane" class="mr-1"></fa>{{final_completed==false?'제출하기':'제출됨'}}
        </b-button> -->
        <b-alert :show="completed_error" variant="danger" class="f-90">
            제출 상태를 불러오지 못해 종합의견을 편집할 수 없습니다. 이미 제출된 의견일 수 있습니다.
            <b-button size="sm" variant="dark-border" class="ml-2" @click="readCompleted">다시 불러오기</b-button>
        </b-alert>
        <b-form-checkbox v-model="final_completed_temp" switch @change="showSubmitAudit" :disabled="completed_error||(final_completed==true&&is_admin!=4)" 
        class="mb-2" :class="final_completed==false?'blue fw-500 even-switch':''">
            {{final_completed==false?'제출하기':'제출됨'}} {{is_admin==4&&final_completed==true?'해제하기':''}}
        </b-form-checkbox>

        <b-button @click="openPreviewModal" class="mb-1 mr-2" variant="dark-border"><fa icon="pen" class="mr-1"></fa>큰 화면에서 작성 / 미리보기</b-button>
        <b-button v-if="show_score!=true" @click="readAndShowScore()" class="mb-1 " variant="dark-border"><fa icon="chart-pie" class="mr-1"></fa>현재 점수/등급 보기</b-button>
        <b-button v-else @click="show_score=false" class="mb-1" variant="dark-border"><fa icon="times" class="mr-1"></fa>점수/등급 닫기</b-button>

        <b-modal ref="submit_audit" :title="'전문가 종합의견 제출'" hide-footer @hidden="final_completed_temp = final_completed">
            <div v-if="final_completed==false" class="pt-5 text-center mb-5 fw-500">제출시 종합의견을 수정하실 수 없습니다. <br> 제출 하시겠습니까?</div>
            <div v-else class="pt-5 text-center mb-5 fw-500 green">제출된 종합의견을 수정하시겠습니까?<br> 수정 후 반드시 다시 제출해주세요.</div>
            <div class="text-right py-2">
                <b-button :variant="final_completed==false?'blue':'green'" @click.stop="setCompleted" :disabled="is_completing==true">
                    <b-spinner v-if="is_completing==true" class="white mr-2" size="sm"></b-spinner>예, {{final_completed==false?'제출하겠습니다.':'수정하겠습니다.'}}
                </b-button>
                <b-button variant="dark" class="ml-2" :disabled="is_completing==true" @click="hideSubmitAudit">취소</b-button>
            </div>
        </b-modal>

        <b-card v-if="show_score==true" class="mb-4 bgray-200">
            <template v-if="is_bm_distribution_loaded==true">
                <div class="mb-2">총점 : {{ total_score }} 점</div>
                <div class="mb-2">등급 : <span class="f-140 fw-500">{{ now_project.manager=='NICE'? my_code : my_rate }}</span></div>
                <div>등급수준 : {{ get_rate_comment }} </div>
                <hr>
                <div class="d-flex mb-2">
                    <div class="pr-3">부문등급: </div>
                    <div>
                        <p v-for="cats in cat_name" :key="cats.id" class="mb-0 fw-400">
                            {{$t(cats)}} : <span class="fw-500">{{getCategoryCode(cats)}} </span>
                        </p>
                    </div>
                </div>
                <span class="f-85">* 등급분포: AAA(1) - AA(2) - A(3) - BBB(4) - BB(5) - B(6) - C(7)</span>      
            </template>
            <div v-else-if="score_failed" class="f-90 red5">
                점수/등급을 불러오지 못했습니다. 점수/등급 닫기 후 다시 눌러 주세요.
            </div>
            <template v-else>
                <b-skeleton></b-skeleton>
            </template>
        </b-card>
       
        <b-modal id="conclusion-preview" title="큰 화면에서 작성 / 미리보기" size="xl" hide-footer>
            <template v-if="is_editing==true||audit_conclusion.conclusion==undefined">
                <b-button v-b-tooltip.hover="'저장하지 않은 수정 내용을 버리고 저장본으로 돌아갑니다.'" variant="dark-border" class="mb-3" @click="cancelConclusionEdit"> 작성 취소 </b-button>
                <h6 class="pb-3 f-120 tail-line"> 전문가 종합의견 </h6>
                <b-form-textarea :rows="12" max-rows="30" v-model="audit_conclusion.conclusion" :placeholder="answer_company.company_name+`의 평가결과에 대한 전문가 종합 의견을 작성하여 주십시오.`" class="mb-1"></b-form-textarea>
                <div class="text-right mb-3"> <b-button variant="blue" size="sm" :disabled="completed_error" @click.stop.prevent="handleSaveConclusion"> 저장</b-button></div>

                <div v-for="(item, index) in audit_recommendations" :key="index" class="mb-4">
                    <template v-if="is_editing_recommendation[index]==true">            
                        <div class="d-flex justify-content-between align-items-end mb-2">
                            <div class="fw-500 mb-1 f-90">개선과제 {{ index+1 }}.</div>
                            <b-form-input v-model="item.title" placeholder="개선과제명을 입력하여 주십시오." class="recommend-title" style="width:calc(100% - 80px)"></b-form-input>
                        </div>
                        <b-form-textarea :rows="5" max-rows="30" v-model="item.recommendation" placeholder="개선과제 내용을 작성하여 주십시오." class="mb-1"></b-form-textarea>
                        <div class="text-right"> <b-button variant="blue" size="sm" :disabled="completed_error" @click.stop.prevent="handleSaveRecommendation(item, index)"> 저장</b-button></div>
                    </template>
                </div>
            </template>
            <template v-else>
                <div class="mb-4 d-flex justify-content-between"> 
                    <div class="d-flex align-items-center fw-500">
                        <general-print-button print_target="audit-report-preview" :file_title="`${answer_company.company_name} 전문가 종합의견`" :btn_variant="'dark-border'" class="mr-2"
                        @modal-opened="is_printing=true" @modal-closed="is_printing=false"> 인쇄하기 <fa icon="print" class="ml-2"></fa>
                        </general-print-button>
                        작성하신 분량 확인을 위해 '인쇄하기'로 확인해주세요. 1페이지가 넘어가지 않도록 작성 부탁드립니다.
                    </div>
                    <b-button variant="red" :disabled="final_completed==true" @click="is_editing=true" v-b-tooltip.hover="'종합의견 수정하기'"> <fa icon="pen"></fa></b-button>
                </div>
                <div id="audit-report-preview" :class="is_printing==true? 'font-scale-up':''" >
                    <section class="min-vh-100 bg-white" :class="is_printing==true?'':'mb-5 shadow-md'">
                        <div class="pt-5 px-8"><div class="bgray-900 gray-50 px-3 py-1 d-flex justify-content-between">{{ answer_company.company_name }}</div></div>
                        <section  :style="is_printing==true?'height: calc(100vh - 154px)':''" class="pt-5 px-8">
                            <total-conclusion></total-conclusion>
                        </section>
                        <div class="px-8 bg-reportbg2 d-flex align-item-center justify-content-between" style="height:80px">
                            <b-img src="/images/QuantifiedESG_Logo_v3_Basic.svg" alt="QESG" style="width: 110px;"></b-img> 
                        </div>
                    </section>
                    <section class="min-vh-100 bg-white" :class="is_printing==true?'':'mb-5 shadow-md'">
                        <div class="pt-5 px-8"><div class="bgray-900 gray-50 px-3 py-1 d-flex justify-content-between">{{ answer_company.company_name }}</div></div>
                        <section  :style="is_printing==true?'height: calc(100vh - 154px)':''" class="pt-5 px-8">
                            <to-be-improved></to-be-improved>
                        </section>
                        <div class="px-8 bg-reportbg2 d-flex align-item-center justify-content-between" style="height:80px">
                            <b-img src="/images/QuantifiedESG_Logo_v3_Basic.svg" alt="QESG" style="width: 110px;"></b-img> 
                        </div>
                    </section>
                </div>
            </template>
        </b-modal>

        <div v-if="is_conclusions_saved==true"> {{ audit_conclusion.auditor_name }} {{ audit_conclusion.time_stamp }} </div>
        <h6 class="pt-5 pb-3 f-120 tail-line"> 전문가 종합의견 </h6>

            <template v-if="is_editing==true||audit_conclusion.conclusion==undefined">
                <b-form-textarea :rows="29" max-rows="29" v-model="audit_conclusion.conclusion" :placeholder="answer_company.company_name+`의 평가결과에 대한 전문가 종합 의견을 작성하여 주십시오.`" class="mb-1"></b-form-textarea>
                <div class="text-right"> <b-button variant="blue" size="sm" :disabled="completed_error" @click.stop.prevent="handleSaveConclusion"> 저장</b-button></div>
            </template>
            <template v-else>
                
                <div class="should-html">{{ brToNewline(audit_conclusion.conclusion) }}</div>
                <template v-if="final_completed==false">
                    <div class="text-right"> <b-button variant="dark-border" size="sm" @click="is_editing=true"> <fa icon="pen"></fa></b-button></div>
                </template>
            </template>

        <hr class="border-0 mb-5">

        <h6 class="pb-3 f-120 tail-line"> 핵심 개선과제 </h6>
            <div v-for="(item, index) in audit_recommendations" :key="index" class="mb-4">
                <template v-if="is_editing_recommendation[index]==true && final_completed==false">            
                    <div class="d-flex justify-content-between align-items-end mb-2">
                        <div class="fw-500 mb-1 f-90">개선과제 {{ index+1 }}.</div>
                        <b-form-input v-model="item.title" placeholder="개선과제명을 입력하여 주십시오." class="recommend-title" style="width:calc(100% - 80px)"></b-form-input>
                    </div>
                    <b-form-textarea :rows="5" max-rows="30" v-model="item.recommendation" placeholder="개선과제 내용을 작성하여 주십시오." class="mb-1"></b-form-textarea>
                    <div class="text-right"> <b-button variant="blue" size="sm" :disabled="completed_error" @click.stop.prevent="handleSaveRecommendation(item, index)"> 저장</b-button></div>
                </template>
                <template v-else>

                    <div class="d-flex align-items-center mb-2 bgray-200 px-2 py-1">
                        <div class="gray-600 mr-2 f-90">개선과제 {{ index+1 }}.</div><div class="fw-500 f-105">{{ brToNewline(item.title) }}</div>
                    </div>
                    <div class="px-2 should-html">{{ brToNewline(item.recommendation) }}</div>
                    <template v-if="final_completed==false">
                        <div class="text-right"> 
                            <b-button variant="dark-border" size="sm" title="수정" aria-label="수정" @click="is_editing_recommendation.splice(index, 1, true)"> <fa icon="pen"></fa></b-button>
                            <b-button variant="dark-border" size="sm" title="삭제" aria-label="삭제" @click="handleDeleteRecommendation(index, item.rec_code, item.title)"> <fa icon="trash-alt"></fa></b-button>
                        </div>
                     </template>
                </template>         
            </div>
        <!-- <b-overlay :show="final_completed==true" rounded="sm" opacity="0.8" bg-color="#efefef">
            <template v-slot:overlay>
                    <div class="text-center gray-600 f-110" v-b-tooltip.hover :title="pipeline_title">
                        전문가 종합의견 <br><strong>'작성완료'</strong> 상태 입니다.
                    </div>
            </template>
        </b-overlay> -->
     
    
            <b-button v-if="final_completed==false" variant="dark-border" @click="addRecommend"> <fa icon="plus" class="mr-2"></fa> 개선과제 추가</b-button>      
            
        
    <!-- </div> -->
</div>  
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import * as ih from '@core_utils/util'
// import AuditConclusionReport from '@/components/main/result_components/audit_report_subs/AuditConclusionReport.vue'
import GeneralPrintButton from '@shared_components/admin/components/common/GeneralPrintButton'
import TotalConclusion from '@shared_components/admin/components/audit/TotalConclusion.vue'
import ToBeImproved from '@shared_components/admin/components/audit/ToBeImproved.vue'

export default {
    name: "AuditConclustion",
    components: {
        // AuditConclusionReport,
        GeneralPrintButton,
        TotalConclusion,
        ToBeImproved
    },
    data() {
        return {
            final_completed: false,
            final_completed_temp: false,
            is_completing: false,
            completed_error: false,
            score_failed: false,
            // 저장된 값(편집 시작 시점). 이와 달라지면 미저장 편집으로 본다
            conclusion_baseline: '',
            rec_baseline: {},
            audit_conclusion: {
                auditor_name: '',
                conclusion: '',
                time_stamp: ''
            },
            audit_recommendations:[{
                rec_code: '0',
                auditor_name: '',
                title: '',
                recommendation: '',
                time_stamp: ''
                },
                {
                rec_code: '1', 
                auditor_name: '',
                title: '',
                recommendation: '',
                time_stamp: ''
                }]
            ,
            is_conclusions_saved: false,
            is_editing: false,
            is_editing_recommendation: [],
            is_printing: false,
            show_score: false,
            esg_rates: [
                { rate: 'ESG-1', description: '환경, 사회, 거버넌스(ESG) 위험과 기회 요인을 매우 충실한 수준에서 관리/통제하고 있으며, 비재무적 요인으로 인한 이해관계자 가치 향상 가능성이 매우 높음'},
                { rate: 'ESG-2', description: '환경, 사회, 거버넌스(ESG) 위험과 기회 요인을 충실한 수준에서 관리/통제하고 있으며, 비재무적 요인으로 인한 이해관계자 가치 향상 가능성이 높음'},
                { rate: 'ESG-3', description: '환경, 사회, 거버넌스(ESG) 위험과 기회 요인을 적절한 수준에서 관리/통제하고 있으며, 비재무적 요인으로 인한 이해관계자 가치 향상 가능성이 있음'},
                { rate: 'ESG-4', description: '환경, 사회, 거버넌스(ESG) 위험과 기회 요인을 적절한 수준에서 관리/통제하고 있으며, 비재무적 요인으로 인한 이해관계자 가치 향상 가능성 및 훼손 여지가 낮음'},
                { rate: 'ESG-5', description: '환경, 사회, 거버넌스(ESG) 위험과 기회 요인을 관리/통제하기 위한 노력이 필요하며, 비재무적 요인으로 인한 이해관계자 가치 훼손 여지가 있음'},
                { rate: 'ESG-6', description: '환경, 사회, 거버넌스(ESG) 위험과 기회 요인을 관리/통제하기 위한 노력이 필요하며, 비재무적 요인으로 인한 이해관계자 가치 훼손 여지가 높음'},
                { rate: 'ESG-7', description: '환경, 사회, 거버넌스(ESG) 위험과 기회 요인을 관리/통제하고 있지 못하며, 비재무적 요인으로 인한 이해관계자 가치 훼손 여지가 매우 높음'}
            ],
            cat_name:['환경', '인권 및 노동', '윤리 및 지배구조']
        }
    },
    computed:{
        ...mapState(['is_admin']),
        ...mapState('questions', ['subs', 'subs_loaded', 'answer_company']),
        ...mapState('reviews', ['reviews', 'is_conclusion_loaded', 'is_recommendations_loaded']),
        ...mapState('industry_scores', ['category1_score','category2_score', 'total_score', 'my_code', 'my_rate', 'category1_distribution', 'is_bm_distribution_loaded']),
        ...mapState('project_code',['now_project']),

        user_name() {
            return this.$store.state.user_name
        },
        campaign() {
            return this.$store.state.campaign
        },
        // 종합의견/개선과제에 저장하지 않은 편집이 있는지 (부모 화면의 이탈 경고용)
        has_unsaved(){
            if ((this.audit_conclusion.conclusion ?? '') !== this.conclusion_baseline) return true
            return this.audit_recommendations.some(item => this.recSignature(item) !== (this.rec_baseline[item.rec_code] ?? ''))
        },
        get_rate_comment(){
            if (this.my_code!=''){
                let new_idx = this.esg_rates.findIndex(x => x.rate == this.my_code)
                if (new_idx>-1){
                    return this.esg_rates[new_idx].description
                }else return ''
            }else return ''
        },
    },
    watch:{
        has_unsaved:{
            immediate: true,
            handler(val){
                this.$emit('dirty-change', val)
            }
        }
    },
    async created(){
        this.initiateAuditConclusion()
        this.initiateAuditRecommendations()
        await this.readCompleted()
    },
    beforeDestroy(){
        this.update_is_recommendations_loaded(false)
        this.update_is_conclusion_loaded(false)        
        this.reset_industry_scores(true)
        this.$emit('dirty-change', false)
    },
    methods:{
        // 입력이 평문 textarea 라 출력도 평문으로. 예전에 <br> 로 줄을 바꿔 저장한 글은 줄바꿈으로 보여 준다
        brToNewline(text){
            return String(text ?? '').replace(/<br\s*\/?>/gi, '\n')
        },
        async cancelConclusionEdit(){
            if ((this.audit_conclusion.conclusion ?? '') !== this.conclusion_baseline) {
                const confirmed = await this.$showModal({
                    type: 'confirm',
                    state: 'warning',
                    title: '작성 취소',
                    message: '작성 중인 종합의견을 버릴까요? 저장하지 않은 수정 내용은 사라지고 저장본으로 돌아갑니다.',
                    modalOptions: { okTitle: '버리기', cancelTitle: '계속 작성' }
                })
                if (!confirmed) return
            }
            this.$set(this.audit_conclusion, 'conclusion', this.conclusion_baseline)
            this.is_editing = false
        },
        recSignature(item){
            return `${item.title ?? ''}\u0000${item.recommendation ?? ''}`
        },
        snapshotRecommendations(){
            this.rec_baseline = this.audit_recommendations.reduce((acc, item) => {
                acc[item.rec_code] = this.recSignature(item)
                return acc
            }, {})
        },
        ...mapActions('reviews', ['saveAuditConclusion', 'saveAuditRecommendation','deleteRecommendation']),
        ...mapMutations('reviews', ['update_is_conclusion_loaded','update_is_recommendations_loaded']),
        ...mapActions('reviews',['readConclusionbyCompany', 'readRecommendationsbyCompany', 'initiateReviews']),
        ...mapActions('industry_scores', ['readQeCrScores']),
        ...mapMutations('industry_scores', ['reset_industry_scores']),

        initiateAuditConclusion(){
            let temp_audit_conclusion = this.findAuditConclusion(this.answer_company.company_id) 
            //console.log(temp_rev)
            let conclusion_obj = {}
            if(temp_audit_conclusion != undefined){
                conclusion_obj = temp_audit_conclusion
            } else {
                conclusion_obj = {
                    conclusion_id: null,
                    auditor_name: '',
                    conclusion: '',
                    time_stamp: ''
                }
                this.is_editing = true
            }
            this.audit_conclusion = conclusion_obj
            this.conclusion_baseline = conclusion_obj.conclusion ?? ''
        },
        initiateAuditRecommendations () {
            let temp_audit_recommendations = this.findAuditRecommendations(this.answer_company.company_id) 
            // console.log(temp_audit_recommendations);
            let temp_rec = []
            if(temp_audit_recommendations == undefined || temp_audit_recommendations.length == 0){
                temp_rec = [{
                        rec_code: 'rc'+ Math.floor(Math.random()*10000000000),
                        auditor_name: '',
                        title: '',
                        recommendation: '',
                        time_stamp: ''
                    },
                    {
                        rec_code: 'rc'+ Math.floor(Math.random()*10000000000), 
                        auditor_name: '',
                        title: '',
                        recommendation: '',
                        time_stamp: ''
                    }
                ]
                this.is_editing_recommendation = []
                for (let i = 0; i < temp_rec.length; i++) {
                    this.is_editing_recommendation.push(true)
                }
            } else {
                temp_rec = temp_audit_recommendations
                this.is_editing_recommendation = []
                for (let i = 0; i < temp_rec.length; i++) {
                    this.is_editing_recommendation.push(false)
                }                
            }
            this.audit_recommendations = temp_rec
            this.snapshotRecommendations()
        },
        async readCompleted () {
            try {
                const response = await this.$axios.get('/read_audit_completed', { params: {company_id: this.answer_company.company_id, campaign_id: this.answer_company.campaign_id}})
                this.completed_error = false
                if(response.data.code === 'completed') {
                    this.final_completed = true
                    this.final_completed_temp = true
                }
            } catch (error) {
                // 제출 여부를 모르는 채로 편집하게 두지 않는다
                this.completed_error = true
            }
            // const path = this.$store.state.backend_host + '/read_audit_completed'
            // axios.get( path, { params: {company_id: this.answer_company.company_id, campaign_id: this.answer_company.campaign_id}})
            // .then(response =>{    
            //     if(response.data.code =='completed'){
            //         this.final_completed = true
            //         this.final_completed_temp = true
            //     }}
            // )
        },
        findAuditRecommendations (company_id) {
            let idx = this.reviews.findIndex(item => item.company_id == company_id)
            if (idx > -1) {
                return ih.deepCopy(this.reviews[idx].audit_recommendations)
            } else {
                return undefined
            }
        },
        addRecommend(){
            this.audit_recommendations.push(
                {
                    rec_code: 'rc' + Math.floor(Math.random()*10000000000), 
                    campaign_id:this.answer_company.campaign_id, 
                    company_id:this.answer_company.company_id, 
                    auditor_name: '',  
                    recommendation: '', 
                    time_stamp: ''
                })
            this.is_editing_recommendation.push(true)
        },
        findAuditConclusion(company_id){
            let idx = this.reviews.findIndex(item => item.company_id == company_id)
            if (idx > -1){
                return ih.deepCopy(this.reviews[idx].audit_conclusion)
            }
            else return undefined
        },
        
        async handleSaveConclusion(){
            try {
                let response = await this.saveAuditConclusion( {
                    campaign_id: this.answer_company.campaign_id,
                    company_id: this.answer_company.company_id,
                    auditor_name: this.$store.state.user_name,
                    conclusion: this.audit_conclusion.conclusion
                })
                this.audit_conclusion = response
                this.conclusion_baseline = response.conclusion ?? ''
                this.is_editing = false
                this.$EventBus.$emit('toast-success', '저장 완료', '종합의견을 저장하였습니다.')
                await this.initiatePreviewModal()
            } catch (error) {
                // 입력한 내용은 그대로 둔다
                this.$EventBus.$emit('toast-failure', '저장 실패', '종합의견을 저장하지 못했습니다. 입력한 내용은 그대로 남아 있으니 다시 시도해 주세요.')
            }
        },
        async handleSaveRecommendation(item, index){
            try {
                let response = await this.saveAuditRecommendation( {
                    rec_code: item.rec_code,
                    campaign_id: this.answer_company.campaign_id,
                    company_id: this.answer_company.company_id,
                    auditor_name: this.$store.state.user_name,
                    title: item.title,
                    recommendation: item.recommendation
                })
                this.audit_recommendations.splice(index, 1, response)
                this.rec_baseline = {...this.rec_baseline, [response.rec_code]: this.recSignature(response)}
                this.is_editing_recommendation.splice(index, 1, false)
                this.$EventBus.$emit('toast-success', '저장 완료', `개선과제 ${index + 1}을 저장하였습니다.`)
            } catch (error) {
                this.$EventBus.$emit('toast-failure', '저장 실패', `개선과제 ${index + 1}을 저장하지 못했습니다. 입력한 내용은 그대로 남아 있으니 다시 시도해 주세요.`)
            }
        },
        async handleDeleteRecommendation(index, rec_code, title){
            const confirmed = await this.$showModal({
                type: 'confirm',
                state: 'error',
                title: '개선과제 삭제',
                message: `개선과제 ${index + 1}${title ? ` "${String(title).replace(/<[^>]*>/g, '')}"` : ''}을(를) 삭제합니다. 결과보고서에서도 사라지며 되돌릴 수 없습니다. 삭제하시겠습니까?`,
            })
            if (!confirmed) return
            try {
                await this.deleteRecommendation({company_id:this.answer_company.company_id, rec_code:rec_code})
                this.audit_recommendations.splice(index, 1)
                this.is_editing_recommendation.splice(index, 1)
                this.$EventBus.$emit('toast-success', '삭제완료', '개선과제를 삭제하였습니다.')
            } catch (error) {
                this.$EventBus.$emit('toast-failure', '삭제 실패', '개선과제를 삭제하지 못했습니다. 잠시 후 다시 시도해 주세요.')
            }
        },
        async openPreviewModal () {
            await this.initiatePreviewModal()
            this.$bvModal.show('conclusion-preview')
            this.is_editing_recommendation = [true, true, true]
        },
        async initiatePreviewModal () {
            await this.readConclusionbyCompany({company_id: this.answer_company.company_id, campaign_id: this.answer_company.campaign_id})
            await this.readRecommendationsbyCompany({company_id: this.answer_company.company_id, campaign_id: this.answer_company.campaign_id })
        },
        async readAndShowScore(){
            this.show_score = true
            this.score_failed = false
            try {
                await this.readQeCrScores({
                    company_id: this.answer_company.company_id,
                    campaign_id: this.answer_company.campaign_id,
                    project_code: this.answer_company.project_code
                })
            } catch (error) {
                // 스토어가 오류를 삼키므로 아래 로딩 여부로도 실패를 판정한다
            }
            this.score_failed = !this.is_bm_distribution_loaded
        },
        getCategoryCode(cat1_name){
            let idx = this.category1_distribution.findIndex(x => x.category1_name == cat1_name)
            if(idx >-1){
                if (this.now_project.manager=='NICE'){
                    return this.category1_distribution[idx].my_code
                }else return this.category1_distribution[idx].my_rate
            }else return ' - '
        },    
        
        async setCompleted () {      
            this.is_completing = true

            const path = this.final_completed === true
                ? '/update_audit_incompleted'
                : '/update_audit_completed'

            try {
                const response = await this.$axios.get(path, {
                    params: {
                        company_id: this.answer_company.company_id,
                        campaign_id: this.answer_company.campaign_id
                    }
                })
                if (response.data.code === 'success') {
                    if (this.final_completed === false) {
                        this.final_completed = true
                        this.final_completed_temp = true
                    } else {
                        this.final_completed = false
                        this.final_completed_temp = false
                    }
                    this.hideSubmitAudit()
                    this.$EventBus.$emit('toast-success', '처리 완료', this.final_completed ? '종합의견을 제출하였습니다.' : '제출을 해제하였습니다. 수정 후 반드시 다시 제출해주세요.')
                } else {
                    throw new Error(response.data.code)
                }
            } catch (error) {
                this.$EventBus.$emit('toast-failure', '처리 실패', '제출 상태를 변경하지 못했습니다. 잠시 후 다시 시도해 주세요.')
            } finally {
                this.is_completing = false
            }

            // let path = this.$store.state.backend_host + '/update_audit_completed'
            // if (this.final_completed==true){
            //     path = this.$store.state.backend_host + '/update_audit_incompleted'
            // }
            
            // axios.get( path, { params: {company_id: this.answer_company.company_id, campaign_id: this.answer_company.campaign_id}})
            // .then(response =>{
            //     // console.log(response.data);
            //     if(response.data.code =='success'){
            //         if (this.final_completed==false){
            //             this.final_completed = true
            //             this.final_completed_temp = true
            //         }else {
            //             this.final_completed = false    
            //             this.final_completed_temp = false
            //         }
            //         this.is_completing = false
            //         this.hideSubmitAudit()
            //     }})
        },

        showSubmitAudit(){
            this.$refs['submit_audit'].show()
        },
        hideSubmitAudit(){
            this.$refs['submit_audit'].hide()
        },           
    }
}
</script>

<style>
.recommend-title.form-control{
    padding: 0.2rem ;
    font-size: 1.02rem;
    height: auto;
    border:0;
    border-radius: 0;
    border-bottom: 1px solid var(--gray-400);
}
.recommend-title.form-control:focus,
.recommend-title.form-control:hover{
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
    border:0;
    border-bottom: 1px solid var(--gray-700);
}

#audit-report-preview,
#conclusion-preview,
.should-html{
    white-space: pre-line;
}
</style>